import { useLoadPartners } from "@/network/useLoadPartners";

export const usePartner = (partnerUid = "curai") => {
  const { data, isLoading } = useLoadPartners();
  const partner = data?.find((partner) => partner.partnerUid === partnerUid);
  return { partner, isLoading };
};
